import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import Typography from "@material-ui/core/Typography"
import { injectIntl } from "gatsby-plugin-intl"
import Layout from "../components/layout"
import SEO from "../components/seo"
import MainToolbar from "../components/main-toolbar"
import LeadIntakeForm, {
  PRESETS,
} from "../components/LeadIntake/LeadIntakeForm"

const useStyles = makeStyles((theme) => ({
  page: { backgroundColor: "#0e0e0e", minHeight: "100vh" },
  body: {
    paddingTop: 44,
    paddingBottom: 90,
    [theme.breakpoints.down("xs")]: { paddingTop: 28, paddingBottom: 60 },
  },
  inner: { maxWidth: 860, margin: "0 auto" },
  title: {
    color: "white",
    fontSize: "2.3rem",
    fontWeight: 300,
    lineHeight: 1.15,
    marginBottom: 12,
    [theme.breakpoints.down("xs")]: { fontSize: "1.8rem" },
  },
  intro: {
    color: "#cfcccf",
    fontSize: "1.1rem",
    lineHeight: 1.6,
    maxWidth: 640,
    marginBottom: 28,
  },
}))

// Links from treatment pages, ads and emails can preselect the treatment:
// /book/?treatment=facelift | nose | injectables
const presetFromUrl = () => {
  if (typeof window === "undefined") return undefined
  const value = new URLSearchParams(window.location.search).get("treatment")
  return PRESETS[value] ? value : undefined
}

const BookPage = ({ intl, location }) => {
  const classes = useStyles()
  const t = (id) => intl.formatMessage({ id })
  // Read after mount, so the server-rendered page matches the first render.
  const [preset, setPreset] = useState(undefined)
  useEffect(() => setPreset(presetFromUrl()), [])

  return (
    <Layout>
      <SEO
        lang={t("global.lang")}
        title={t("book.SEOtitle")}
        description={t("book.SEO")}
        path={location.pathname}
      />
      <div className={classes.page}>
        <MainToolbar black />
        <Container maxWidth="lg" className={classes.body}>
          <div className={classes.inner}>
            <Typography component="h1" className={classes.title}>
              {t("book.title")}
            </Typography>
            <Typography className={classes.intro}>{t("book.intro")}</Typography>
            <LeadIntakeForm
              key={preset || "none"}
              preset={preset}
              withQuote={false}
            />
          </div>
        </Container>
      </div>
    </Layout>
  )
}

BookPage.propTypes = {
  location: PropTypes.object.isRequired,
}

export default injectIntl(BookPage)
